import React, { useState, lazy, Suspense } from "react";
import Hero from "../components/home/Hero";
import SplashScreen from "../components/SplashScreen";
import PageSEO from "../seo/PageSEO";
import { BreadcrumbSchema } from "../components/SEO";

const HomeDeferred = lazy(() =>
  import(/* webpackChunkName: "home-deferred" */ "./HomeDeferred"),
);

const SPLASH_STORAGE_KEY = "dx_intro_v1";

export default function HomePage() {
  const [showSplash, setShowSplash] = useState(() => {
    try {
      return sessionStorage.getItem(SPLASH_STORAGE_KEY) !== "1";
    } catch {
      return true;
    }
  });

  const onSplashComplete = () => {
    try {
      sessionStorage.setItem(SPLASH_STORAGE_KEY, "1");
    } catch {
      /* private / disabled storage */
    }
    setShowSplash(false);
  };

  return (
    <>
      <PageSEO
        title="Software Development Company | Scalable Digital Products | Dexton Technology"
        description="Dexton Technology builds mobile apps, web platforms, and custom software for startups and enterprises worldwide—React Native, Next.js, ERP/CRM, AI, and cloud solutions with structured delivery."
        keywords="software development company, mobile app development, React Native development, web development company, custom software development, AI development company, cloud solutions"
        path="/"
      />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://dextontechnology.com/" }]} />

      {showSplash ? <SplashScreen onComplete={onSplashComplete} /> : null}

      <div
        aria-hidden={showSplash || undefined}
        className={showSplash ? "pointer-events-none select-none" : undefined}
      >
        <Hero />
        <Suspense
          fallback={
            <div
              className="min-h-[50vh] w-full animate-pulse bg-gradient-to-b from-zinc-100/80 via-zinc-100/60 to-white"
              aria-hidden
            />
          }
        >
          <HomeDeferred />
        </Suspense>
      </div>
    </>
  );
}
